import React, { FC } from 'react';
import { Icon, IconProps } from '@agria/theme/src/components/icon/Icon';

export const Info: FC<IconProps> = (props) => (
  <Icon {...props}>
    <path
      fill="#276AE6"
      d="M16 1.5C7.98545 1.5 1.5 7.99864 1.5 16c0 8.0014 6.48545 14.5 14.5 14.5 8.0145 0 14.5-6.4855 14.5-14.5 0-8.01455-6.4855-14.5-14.5-14.5Zm1.3182 23.7273h-2.6364V13.3636h2.6364v11.8637ZM16 10.7273c-1.0941 0-1.9773-.88321-1.9773-1.9773S14.9059 6.77273 16 6.77273s1.9773.88318 1.9773 1.97727-.8832 1.9773-1.9773 1.9773Z"
    />
  </Icon>
);
